import { columnTypes } from '@/services/Grid/ColumnTypes';
import TooltipComponent from '@/components/Grid/Renderers/TooltipComponent.vue';
import { cloneDeep, startCase, toLower } from 'lodash';
import WorkPlansEditButtonsRenderer from '@/components/Grid/Renderers/WorkPlansEditButtonsRenderer';

function CapitilizeValue({ value }) {
  return startCase(toLower(value));
}

/* Work Plans */
export const workPlansGridDefaultColDef = {
  filter: 'agSetColumnFilter',
  resizable: true,
  sortable: true,
  filterParams: {
    selectAllOnMiniFilter: false,
  },
};

export const workPlansGridColumnTypes = columnTypes;

const grid = [
  {
    headerName: 'Plan name',
    enablePivot: true,
    field: 'name',
    colId: 'name',
    width: 230,
    minWidth: 230,
    filter: 'agSetColumnFilter',
    aggFunc: 'count',
    enableValue: true,
  },
  {
    headerName: 'Due date',
    field: 'dueDate',
    width: 130,
    minWidth: 130,
    enablePivot: true,
    enableRowGroup: true,
    type: 'dateColumn',
  },
  {
    headerName: 'Actions',
    field: 'actionsCount',
    width: 180,
    minWidth: 180,
    enablePivot: true,
    enableRowGroup: true,
    sort: 'desc',
  },
  {
    headerName: 'Actions',
    width: 180,
    minWidth: 180,
    enablePivot: true,
    enableRowGroup: true,
    cellRendererFramework: WorkPlansEditButtonsRenderer,
  },
];

export const workPlansGridColumns = grid;

export const queryGridColumns = [
  {
    headerName: 'Query With',
    enablePivot: true,
    enableRowGroup: true,
    field: 'queryUser',
    colId: 'queryUser',
    width: 150,
    minWidth: 150,
    filter: 'agSetColumnFilter',
  },
];

export const getWorkPlansGridColumns = () => cloneDeep(workPlansGridColumns);

